export default {
    errMsg: ''
}